import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DiputadosStats } from './pages/DiputadosStats';
import { DiputadoDetail } from './pages/DiputadoDetail';
import { About } from './pages/About';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { NotFound } from './pages/NotFound';
import { AppFooter } from './components/AppFooter';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1">
        <div className="flex-1" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Navigate to="/stats" replace data-id="element-5" />} data-id="element-4" />
            <Route path="/stats" element={<DiputadosStats data-id="element-7" />} data-id="element-6" />
            <Route path="/diputado" element={<DiputadoDetail data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-13" />} data-id="element-12" />
            <Route path="*" element={<NotFound data-id="element-15" />} data-id="element-14" />
          </Routes>
        </div>
        <AppFooter data-id="element-16" />
      </div>
    </BrowserRouter>;
}